import { FeapiError } from '@edreamsodigeo/frontend-api-client';

export const transformSuccessQuery = <
  T,
  D,
  Q extends {
    data: D;
    error: FeapiError[] | null;
    loading: boolean;
    extensions: unknown;
  },
  O
>(
  queryState: Q,
  mapFn: (queryState: Q, options: O) => T,
  options: O
) => {
  const { error, loading } = queryState;
  if (error || loading) {
    return { error, loading, data: null, extensions: queryState.extensions };
  }
  return {
    loading: false,
    error: null,
    data: mapFn(queryState, options),
    extensions: queryState.extensions,
  };
};
